import pianorecording from '../../../../../../assets/Pianorecording.jpg';
import ulrich from '../../../../../../assets/Ulrichjacket.jpg';
import './jan26.css';
import song from '../../../../../../assets/Jan24Fin.wav';


export default function Jan26() {

  return (

  
    < >

  
    
 
    
    <p className = 'sentence'> 
<img src = {pianorecording} alt = "center" className = "img" /> <br></br> <br></br>

<a href={song} download>
  Download new song here
  
</a> <br></br>

  Scroll down for more


<br></br><br></br>
<img src = {ulrich} alt = "center" className = "img2" /> <br></br> <br></br>
  </p>

  <p> I've been watching this show on netflix called Dark, if you haven't seen it then you should cause its fucking awesome. <br></br><br></br>
Anyways, big ass jackets are the shit, and this is one of the characters in the show. I want his jacket. I also want this jacket called an N-3B. <br></br><br></br>
Its some old military type of parka but it looks cool. Check out this link to one: <a href = "https://www.ebay.com/itm/167800893117?chn=ps&mkevt=1&mkcid=28&google_free_listing_action=view_item&srsltid=AfmBOorTvrxd7Txb86yR_6HMTgbyPRuIQdAE99YiHwYQ_hnrsqbwA3XBtXA"> N-3B Ebay Parka</a></p>
  <div className = "youtube">
  <br></br>youtube: <a href = "https://www.youtube.com/@AugustDiStefano" target = "_blank" rel = "noopener noreferrer">
      https://www.youtube.com/@AugustDiStefano 
    </a>

    </div>
    </>

  )
}
